// extracted by mini-css-extract-plugin
export var accent = "_8f-4";
export var add = "_8f-j";
export var addIcon = "_8f-k";
export var deleteIcon = "_8f-i";
export var disabled = "_8f-9";
export var ellipsis = "_8f-f";
export var error = "_8f-3";
export var form = "_8f-5";
export var hideFocus = "_8f-2";
export var icon = "_8f-7";
export var input = "_8f-e";
export var listItem = "_8f-h";
export var mediumHeight = "_8f-b";
export var noBorder = "_8f-8";
export var noRadius = "_8f-1";
export var shortHeight = "_8f-a";
export var tallHeight = "_8f-c";
export var textInput = "_8f-0";
export var vertical = "_8f-g";
export var veryTallHeight = "_8f-d";
export var widget = "_8f-6";